import NewMessageModal from './NewMessageModal.component';

export default NewMessageModal;